<template>
  <div>
    <div class="flex items-center justify-between">
      <img
        src="/images/shipment/melhorenvio/logo.svg"
        alt="Melhor Envio"
        width="84"
        height="39"
      >
      
      <img
        src="/images/shipment/jadlog/logo-negativo.svg"
        alt="Jadlog"
        width="84"
        height="27"
      >
    </div>

    <h2 class="mt-2 mb-4 text-lg text-center uppercase">Comprovante de Postagem</h2>

    <div class="mb-4 text-xs">
      <div class="flex items-center gap-4 mb-1">
        <div class="flex flex-1 gap-1">
          <p>Unidade de postagem: </p>
          <p class="flex-1 border-b border-black"></p>
        </div>
        
        <div class="flex flex-0 gap-1">
          <p>Data: </p>
          <p class="flex">
            <p class="w-5 border-b border-black"></p>
            <p>/</p>
            <p class="w-5 border-b border-black"></p>
            <p>/</p>
            <p class="w-8 border-b border-black"></p>
          </p>
        </div>
      </div>

      <p>Objetos postados (preencha os espaços com o rastreio dos objetos)</p>
    </div>

    <table class="w-full mb-4">
      <tr v-for="row in rows" :key="row">
        <td
          v-for="column in columns" :key="column"
          class="h-8 border-1 border-black"
        />
      </tr>
    </table>

    <div class="text-xs font-bold">
      <p class="mb-4">Declaro que recebi as remessas acima preenchidas.</p>

      <div class="flex gap-1">
        <p>Assinatura do recebedor:</p>
        <p class="flex-1 border-b border-black"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    rows: {
      type: Number,
      default: 4,
    },
    columns: {
      type: Number,
      default: 2,
    },
  },
};
</script>